<div class="fl-pattern-bg"></div>
<div class="login-mask"></div>
<div class="container-fluid auth-container d-flex flex-column">
  <div class="row">
    <div class="col text-white text-center">
      <img
        class="logo-ol6-signin"
        src="assets/img/logos/EscTech-FrntLn.svg"
        alt="Frontline ERP for California"
      />
      <h1 class="text-white product-name mb-3">Frontline ERP for California</h1>
      <h1 class="text-white product-name mb-3">Agent BMFP</h1>
    </div>
  </div>
  <div class="row flex-grow-1 d-flex flex-column">
    <div class="col-12 flex-grow-1 d-flex flex-column">
      <div class="auth-block-wrapper m-auto">
        <h3 class="text-center mb-3">Sign In</h3>
        <form
          [formGroup]="loginForm"
          class="auth-form"
          (ngSubmit)="submit()"
          novalidate
        >
          <div class="form-group mb-0" aria-live="polite">
            @if (currentErrorMessage; as error) {
              <div
                class="form-message"
                role="alert"
                data-testid="error-message"
              >
                {{ error }}
              </div>
            }
            @if (currentSessionMessage; as sessionInfo) {
              <div class="form-message" data-testid="session-message">
                {{ sessionInfo }}
              </div>
            }

            <label class="et-label mb-1" for="username">Username</label>
            <div>
              <input
                #usernameInput
                type="text"
                id="username"
                name="username"
                formControlName="userName"
                class="form-control auth-control w-100"
                required
                [disabled]="isSubmitting"
                autocomplete="off"
                (keyup.enter)="submit()"
                aria-label="Username"
                data-testid="username-input"
              />
              @if (showUsernameError) {
                <div class="field-error" data-testid="username-error">
                  Username is required.
                </div>
              }
            </div>

            <label class="et-label mb-1" for="password">Password</label>
            <div>
              <input
                type="password"
                id="password"
                name="password"
                formControlName="password"
                class="form-control auth-control w-100"
                required
                [disabled]="isSubmitting"
                autocomplete="off"
                (keyup.enter)="submit()"
                aria-label="Password"
                data-testid="password-input"
              />
              @if (showPasswordError) {
                <div class="field-error" data-testid="password-error">
                  Password is required.
                </div>
              }
            </div>

            <button
              type="button"
              class="btn btn-primary mx-0 w-100"
              [disabled]="isFormDisabled"
              (click)="submit()"
              data-testid="submit-button"
            >
              @if (isSubmitting) {
                Signing in...
              } @else {
                Sign In
              }
            </button>
          </div>
        </form>
      </div>
      <div class="flex-grow-1"></div>
      <footer class="text-center">
        <div class="d-inline-block">
          <a href="https://www.frontlineeducation.com/">About Frontline</a>
          <a href="https://login.frontlineeducation.com/ui/#/terms"
            >Terms &amp; Conditions</a
          >
        </div>
        <span class="text-nowrap"
          >&copy; 2026 Frontline Education. All rights reserved.</span
        >
      </footer>
    </div>
  </div>
</div>
